// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object } from 'prop-types'
import DataHeading from './DataHeading'

const DataHeader = props => {
  const {
    columns,
    handleSort,
    tableSort,
  } = props

  if (props.customHeader) {
    return (
      <props.customHeader
        columns={columns}
        handleSort={handleSort}
        tableSort={tableSort} />
    )
  }

  return (
    <thead>
      <tr>
        {
          columns.map(d => (
            <DataHeading
              key={d.field}
              columnData={d}
              handleSort={handleSort}
              tableSort={tableSort} />
          ))
        }
      </tr>
    </thead>
  )
}

DataHeader.propTypes = {
  columns: array.isRequired,
  customHeader: func,
  handleSort: func,
  tableSort: object,
}

export default DataHeader
